<div [style.list-style]="'inside'">
    @if (component) {
    <div [ngClass]="[component.align || '' , component.style || '', component.color || '']">
        <span *iCms="'text' of component; tag: component.tag; content: 'html'"></span>
    </div>
    }
</div>
